import React from 'react';
import {
    Grid,
    TextField,
    Typography,
    Button,
    IconButton,
    Divider,
    MenuItem,
    useTheme
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { tokens } from '../../../theme/theme';

const conditionTypes = ['Chronic', 'Acute', 'Allergy', 'Infectious', 'Other'];

const EmployeeMedicalConditionSection = ({ medicalConditions, setMedicalConditions }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const handleMedicalChange = (index, e) => {
        const { name, value } = e.target;
        const updated = [...medicalConditions];
        updated[index][name] = value;
        setMedicalConditions(updated);
    };

    const addCondition = () => {
        setMedicalConditions([
            ...medicalConditions,
            {
                conditionName: '',
                diagnosisDate: '',
                conditionType: '',
                treatingDoctor: '',
                hospitalName: '',
                remarks: ''
            }
        ]);
    };

    const removeCondition = (index) => {
        const updated = [...medicalConditions];
        updated.splice(index, 1);
        setMedicalConditions(updated);
    };

    return (
        <>
            {medicalConditions.map((condition, index) => (
                <Grid container spacing={2} key={index} mt={1}>
                    <Grid item xs={12}>
                        <Typography variant="h6">Medical Condition {index + 1}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} lg={5.25} xl={3.5}>
                        <TextField
                            name="conditionName"
                            label="Condition Name"
                            value={condition.conditionName}
                            onChange={(e) => handleMedicalChange(index, e)}
                            fullWidth
                            size="small"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={5.25} xl={3.5}>
                        <TextField
                            name="diagnosisDate"
                            label="Diagnosis Date"
                            type="date"
                            value={condition.diagnosisDate}
                            onChange={(e) => handleMedicalChange(index, e)}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            size="small"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={5.25} xl={3.5}>
                        <TextField
                            select
                            name="conditionType"
                            label="Condition Type"
                            value={condition.conditionType}
                            onChange={(e) => handleMedicalChange(index, e)}
                            fullWidth
                            size="small"
                        >
                            {conditionTypes.map((type) => (
                                <MenuItem key={type} value={type}>
                                    {type}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6} lg={5.25} xl={3.5}>
                        <TextField
                            name="treatingDoctor"
                            label="Treating Doctor"
                            value={condition.treatingDoctor}
                            onChange={(e) => handleMedicalChange(index, e)}
                            fullWidth
                            size="small"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={5.25} xl={3.5}>
                        <TextField
                            name="hospitalName"
                            label="Hospital Name"
                            value={condition.hospitalName}
                            onChange={(e) => handleMedicalChange(index, e)}
                            fullWidth
                            size="small"
                        />
                    </Grid>

                    <Grid item xs={12} lg={10.5} xl={10.5}>
                        <TextField
                            name="remarks"
                            label="Remarks"
                            value={condition.remarks}
                            onChange={(e) => handleMedicalChange(index, e)}
                            fullWidth
                            multiline
                            rows={2}
                            size="small"
                        />
                    </Grid>

                    {index > 0 && (
                        <Grid item xs={12}>
                            <IconButton onClick={() => removeCondition(index)} color="error">
                                <DeleteIcon />
                            </IconButton>
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                </Grid>
            ))}

            <Button
                size="small"
                sx={{ mt: 2, textTransform: 'none' }}
                onClick={addCondition}
                variant="outlined"
                color='secondary'
                startIcon={<AddIcon />}
            >
                Add Medical Condition
            </Button>
        </>
    );
};

export default EmployeeMedicalConditionSection;
